<!-- SVG icon set (referenced by <use> below) -->
<svg width="0" height="0" class="tw-absolute" aria-hidden="true" focusable="false">
  <defs>
    <g id="ns-ico-megaphone" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 11l14-6v14L3 13v-2z" /><path d="M8 12v5a2 2 0 0 0 4 0" /></g>
    <g id="ns-ico-upload" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 16V4M7 9l5-5 5 5" /><path d="M4 20h16" /></g>
    <g id="ns-ico-chart" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 3v18h18" /><rect x="7" y="10" width="3" height="7" /><rect x="12" y="6" width="3" height="11" /><rect x="17" y="13" width="3" height="4" /></g>
    <g id="ns-ico-trend" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 17l6-6 4 4 8-8" /><path d="M17 7h4v4" /></g>
    <g id="ns-ico-vote" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 11l3 3 8-8" /><path d="M20 12v6a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h9" /></g>
    <g id="ns-ico-gift" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="6" cy="7" r="2" /><circle cx="12" cy="12" r="2" /><circle cx="18" cy="6" r="2" /><path d="M8 8l2.5 3M14 11l2.5-3.5" /></g>
    <g id="ns-ico-raise" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20V8" /><path d="M7 13l5-5 5 5" /><path d="M4 4h16" /></g>
  </defs>
</svg>

@if (shouldShow) {
  <div #nsRoot class="issuer-next-steps tw-fixed tw-bottom-6 tw-right-4 tw-z-[999999]" draggable="false">
    <!-- Minimized launcher pill -->
    @if (minimized) {
      <button
        type="button"
        class="ns-pill tw-flex tw-items-center tw-gap-2 tw-rounded-full tw-border tw-border-gray-300 tw-bg-white tw-py-2.5 tw-pl-3.5 tw-pr-4 tw-text-base tw-font-bold tw-text-gray-900 tw-shadow-2xl"
        (click)="toggleMinimized()"
      >
        <svg class="tw-h-4 tw-w-4 tw-text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9z" />
        </svg>
        {{ 'nextSteps.title' | translate }}
        @if (badgeCount > 0) {
          <span class="ns-badge tw-grid tw-h-5 tw-min-w-[20px] tw-place-items-center tw-rounded-full tw-bg-primary tw-px-1.5 tw-text-xs tw-font-bold tw-text-white">{{ badgeCount }}</span>
        }
      </button>
    } @else {
      <!-- Expanded panel -->
      <!-- 420px, not the original 368px. A title-only card shares its row with the
           inline outline CTA; the longest title + its pill needs ~373px, which no
           sane panel width affords, so those titles are EXPECTED to wrap to two
           lines with the pill centred beside them. The extra 52px over 368px is
           for breathing room, not to stop the wrap — don't chase one-line titles
           by widening further. -->
      <div class="ns-shell tw-w-[420px] tw-max-w-[calc(100vw-2rem)] tw-overflow-hidden tw-rounded-2xl tw-border tw-border-gray-300 tw-bg-white tw-shadow-2xl">
        <div class="tw-flex tw-items-center tw-gap-2 tw-border-b tw-border-gray-100 tw-px-4 tw-py-3.5">
          <svg class="tw-h-[18px] tw-w-[18px] tw-text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9z" />
          </svg>
          <span class="tw-text-base tw-font-bold tw-text-gray-900">{{ 'nextSteps.title' | translate }}</span>
          @if (badgeCount > 0) {
            <span class="ns-badge tw-grid tw-h-5 tw-min-w-[20px] tw-place-items-center tw-rounded-full tw-bg-primary tw-px-1.5 tw-text-xs tw-font-bold tw-text-white">{{ badgeCount }}</span>
          }
          <button
            type="button"
            class="ns-collapse tw-ml-auto tw-grid tw-h-8 tw-w-8 tw-flex-none tw-place-items-center tw-rounded-full tw-bg-gray-100 tw-text-gray-500 hover:tw-bg-gray-200 hover:tw-text-gray-700"
            [attr.aria-label]="'nextSteps.minimize' | translate"
            (click)="toggleMinimized()"
          >
            <svg class="tw-h-[18px] tw-w-[18px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6" /></svg>
          </button>
        </div>

        <div #nsBody (scroll)="onBodyScroll()" class="ns-body tw-flex tw-max-h-[45vh] tw-flex-col tw-gap-3 tw-overflow-y-auto tw-overflow-x-hidden tw-bg-gray-50 tw-p-3.5">
          <!-- Actionable cards -->
          @for (card of actionableNudges; track card.key) {
            <!-- Every card is a single row: icon, title, and the outline pill CTA
                 inline at the top-right. -->
            <div class="ns-card tw-relative tw-rounded-xl tw-border tw-border-gray-200 tw-bg-white tw-p-3.5 tw-shadow-sm">
              <!-- ns-head is the hook the mobile media query uses to drop an inline
                   CTA below the title (see the SCSS) — desktop keeps it inline. -->
              <div class="ns-head tw-flex tw-items-center tw-gap-2.5">
                <span class="tw-grid tw-h-9 tw-w-9 tw-flex-none tw-place-items-center tw-rounded-lg" [ngClass]="card.iconWrap">
                  <svg class="tw-h-[17px] tw-w-[17px]" viewBox="0 0 24 24"><use [attr.href]="'#ns-ico-' + card.icon"></use></svg>
                </span>
                <span class="ns-title tw-min-w-0 tw-flex-1 tw-text-[15.5px] tw-font-bold tw-leading-snug tw-text-gray-900">{{ card.kicker | translate }}</span>
                <button
                  type="button"
                  class="ns-pill-cta tw-flex tw-flex-none tw-items-center tw-gap-1 tw-whitespace-nowrap tw-rounded-full tw-border tw-border-primary tw-px-3 tw-py-1.5 tw-text-[12.5px] tw-font-semibold tw-capitalize tw-text-primary tw-transition"
                  (click)="onCta(card)"
                >
                  {{ card.cta | translate }}
                  <svg class="tw-h-3 tw-w-3 tw-flex-none" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14M13 6l6 6-6 6" /></svg>
                </button>
              </div>
            </div>
          }

          <!-- Coming-soon teaser(s): muted, SOON pill, disabled — never counted in the badge -->
          @if (teaserNudges.length > 0) {
            @for (card of teaserNudges; track card.key) {
              <div class="ns-card tw-relative tw-rounded-xl tw-border tw-border-dashed tw-border-gray-200 tw-bg-gray-50/60 tw-p-3.5">
                <div class="tw-flex tw-items-center tw-gap-2.5">
                  <span class="tw-grid tw-h-9 tw-w-9 tw-flex-none tw-place-items-center tw-rounded-lg" [ngClass]="card.iconWrap">
                    <svg class="tw-h-[17px] tw-w-[17px]" viewBox="0 0 24 24"><use [attr.href]="'#ns-ico-' + card.icon"></use></svg>
                  </span>
                  <span class="tw-min-w-0 tw-flex-1 tw-text-[15.5px] tw-font-bold tw-leading-snug tw-text-gray-400">{{ card.kicker | translate }}</span>
                  <span class="tw-flex-none tw-rounded-full tw-bg-warning-light tw-px-2 tw-py-0.5 tw-text-[10px] tw-font-extrabold tw-tracking-wide tw-text-warning">{{ 'nextSteps.soon' | translate }}</span>
                </div>
              </div>
            }
          }
        </div>

        <!-- Mobile carousel position dots (hidden on desktop via SCSS) -->
        <div
          class="ns-dots"
          role="tablist"
          [attr.aria-label]="'nextSteps.dotsGroupLabel' | translate"
          (touchstart)="onDotsTouchStart($event)"
          (touchmove)="onDotsTouchMove($event)"
          (touchend)="onDotsTouchEnd()"
          (touchcancel)="onDotsTouchEnd()"
        >
          @for (n of visibleNudges; track n.key; let i = $index) {
            <button
              type="button"
              class="ns-dot"
              [class.on]="i === activeSlide"
              (click)="goToSlide(i)"
              role="tab"
              [attr.aria-selected]="i === activeSlide"
              [attr.aria-label]="('nextSteps.dotAriaLabel' | translate) + ' ' + (i + 1)"
            ></button>
          }
        </div>
      </div>
    }
  </div>
}
